import React from 'react';
import './Sort.scss';
import { Icon } from '../icon/Icon';
import Dropdown from 'react-bootstrap/Dropdown';
import { ESortDirection, ResponsiveTableColumn } from '../responsive-table/ResponsiveTable';
import { ButtonProps } from 'react-bootstrap/esm/Button';

interface ISortProps<T> {
  columns: ResponsiveTableColumn<T>[];
  selected?: ResponsiveTableColumn<T>;
  selectedDirection?: ESortDirection;
  onChange: (column: ResponsiveTableColumn<T>, sortDirection: ESortDirection) => void;
}

const CustomToggle = React.forwardRef<HTMLButtonElement, ButtonProps>(({ children, onClick }, ref) => (
  <button
    className="sort-button"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      if (onClick) {
        onClick(e);
      }
    }}
  >
    {children}
  </button>
));

export function Sort<T>({ columns, onChange, selected, selectedDirection }: ISortProps<T>): JSX.Element {
  let title = 'Sorteren';
  if (selected) {
    title = selected.title; // eslint-disable-line prefer-destructuring
  }

  let labelIcon = null;
  if (selected && selectedDirection === ESortDirection.DESCENDING) {
    labelIcon = <Icon className="sort__icon" icon="down"/>;
  } else if (selected) {
    labelIcon = <Icon className="sort__icon sort__icon--asc" icon="down"/>;
  }

  const handleClick = (selected: ResponsiveTableColumn<T>, direction: ESortDirection): void => {
    onChange(selected, direction);
  };

  return (
    <Dropdown className="sort">
      <Dropdown.Toggle as={CustomToggle} id="dropdown-sort">
        <Icon className="sort-button__icon" icon="sort"/>{title}{labelIcon}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {
          columns.filter(column => !column.disableSort).map((column, index) => (<div key={index}>
            <Dropdown.Item onClick={() => handleClick(column, ESortDirection.DESCENDING)}>
              {column.title}<Icon className="sort__icon" icon="down"/>
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleClick(column, ESortDirection.ASCENDING)}>
              {column.title}<Icon className="sort__icon sort__icon--asc" icon="down"/>
            </Dropdown.Item>
          </div>))
        }
      </Dropdown.Menu>
    </Dropdown>
  );
}
